"use client";

import SystemErrorNotifier from "@components/SystemErrorNotifier";
import { CvvProvider } from "@lib/contexts/cvv";
import debugContext from "@lib/contexts/debug";
import DebugKey from "@lib/debug_key";
import { useState } from "react";
import AppsignalProvider from "./AppsignalProvider";
import MyApolloProvider from "./MyApolloProvider";

export default function Providers({
  children,
  siteId,
}: {
  children: React.ReactNode;
  siteId: string;
}) {
  const [debugMode, setDebugMode] = useState(false);

  return (
    <AppsignalProvider>
      <debugContext.Provider value={{ debugMode, setDebugMode }}>
        <DebugKey>
          <CvvProvider>
            <SystemErrorNotifier>
              {(showError) => (
                <MyApolloProvider
                  // requestId={pageProps.requestId}
                  showError={showError}
                  siteId={siteId}
                  // sessionId={pageProps.sessionId}
                >
                  {children}
                </MyApolloProvider>
              )}
            </SystemErrorNotifier>
          </CvvProvider>
        </DebugKey>
      </debugContext.Provider>
    </AppsignalProvider>
  );
}
